import React from 'react';
import {
  HiOutlineGlobeAlt,
  HiOutlineBolt,
  HiOutlineLightBulb,
  HiOutlineChartBarSquare,
  HiOutlineMap,
  HiOutlineUserGroup,
} from 'react-icons/hi2';

import { getFounderType } from '../data/founderTypes';

const TYPE_ICON_MAP = {
  visionary: HiOutlineGlobeAlt,
  executor: HiOutlineBolt,
  innovator: HiOutlineLightBulb,
  analyst: HiOutlineChartBarSquare,
  strategist: HiOutlineMap,
  relationshipBuilder: HiOutlineUserGroup,
};

const TypeIcon = ({
  typeId,
  type: typeProp,
  size = 24,
  color = 'currentColor',
  className,
  title,
}) => {
  const type = typeProp || getFounderType(typeId);
  const Icon = TYPE_ICON_MAP[type?.id] || HiOutlineGlobeAlt;

  return (
    <Icon
      size={size}
      color={color}
      className={className}
      aria-hidden={title ? undefined : true}
      title={title}
      role={title ? 'img' : undefined}
    />
  );
};

export default TypeIcon;
